import { format } from "date-fns";

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const today = new Date();

  // Bandingkan tahun, bulan, dan tanggal
  const isSameDay =
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate();

  if (isSameDay) {
    return "Today";
  }

  // Hitung selisih hari berdasarkan tanggal (bukan waktu)
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const isYesterday =
    date.getFullYear() === yesterday.getFullYear() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getDate() === yesterday.getDate();

  if (isYesterday) {
    return "Yesterday";
  }

  // Jika dalam 7 hari terakhir, tampilkan nama hari
  const diffInDays = Math.floor(
    (today.setHours(0, 0, 0, 0) - date.setHours(0, 0, 0, 0)) /
      (1000 * 60 * 60 * 24)
  );
  if (diffInDays <= 7) {
    return format(date, "EEEE"); // Nama hari, misal: "Monday"
  } else {
    return format(date, "dd/MM/yyyy"); // Format 00/00/0000
  }
};
